import { useState } from "react";
import { Button, Alert } from "react-bootstrap";

function ReceiptDownloadButton({ className = "purple-button", text = "Download Payment Receipt" }) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleDownload = async () => {
    setLoading(true);
    setError(null);

    try {
      const API_URL = process.env.REACT_APP_API_URL || "http://localhost:3000";
      const res = await fetch(`${API_URL}/api/v1/payments/receipt`, {
        method: "GET",
        credentials: "include",
      });

      if (!res.ok) {
        throw new Error("Failed to fetch receipt");
      }

      const blob = await res.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "CTGWeb2_Payment_Receipt.pdf";
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      {error && <Alert variant="danger" className="py-1 px-2 mb-2 small">{error}</Alert>}
      <Button
        onClick={handleDownload}
        variant="primary"
        className={className}
        disabled={loading}
      >
        {loading ? "Downloading..." : text}
      </Button>
    </div>
  );
}

export default ReceiptDownloadButton;
